import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Storefront, ChartLineUp, UsersThree, ShieldCheck, ArrowUpRight } from "@phosphor-icons/react";
import SectionEyebrow from "@/components/shared/SectionEyebrow";

const BG = "https://static.prod-images.emergentagent.com/jobs/e1b22ba1-7cff-4c1a-be5f-f374ac624625/images/36cc184c51c91b34cc38d938c078a1fa53fce1243222b4ae670ae94864413cad.png";

const BENEFITS = [
  { icon: UsersThree, title: "Access new customers", desc: "Reach thousands of orders/month across T&T and the Caribbean." },
  { icon: ChartLineUp, title: "Grow visibility", desc: "Be discovered in-app with premium placements and promotions." },
  { icon: Storefront, title: "Merchant dashboard", desc: "Manage menus, orders, payouts and analytics from one place." },
  { icon: ShieldCheck, title: "Delivery infrastructure", desc: "We handle the drivers, routing and customer support — you focus on product." },
];

export default function MerchantSection() {
  return (
    <section className="relative py-24 lg:py-32 border-t border-ih-line overflow-hidden" data-testid="home-merchant">
      <div className="absolute inset-0 opacity-50">
        <img src={BG} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-ih-ink/85 via-ih-ink/95 to-ih-ink" />
      </div>

      <div className="relative max-w-[1400px] mx-auto px-5 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-14">
          <div className="lg:col-span-7 space-y-5">
            <SectionEyebrow label="For merchants" color="electric" />
            <h2 className="font-display font-extrabold text-4xl lg:text-6xl text-white leading-[1.02]">
              Deliver more. <span className="text-white/40">Sell more.</span><br />
              <span className="text-ih-electric">Grow faster.</span>
            </h2>
          </div>
          <p className="lg:col-span-5 text-white/60 text-base lg:text-lg leading-relaxed">
            Restaurants, pharmacies, supermarkets and online stores — plug into IslandHop&apos;s
            delivery network and unlock new revenue, with a transparent <span className="text-white">10–25%</span> commission and tools to scale.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-3 mb-10">
          {BENEFITS.map((b, i) => {
            const Icon = b.icon;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.5, delay: i * 0.06 }}
                data-testid={`merchant-benefit-${i}`}
                className="bg-ih-surface/80 backdrop-blur-md border border-ih-line rounded-2xl p-6 hover:border-ih-electric/40 transition"
              >
                <Icon weight="duotone" size={26} className="text-ih-electric mb-4" />
                <p className="font-display font-bold text-white text-lg mb-1.5">{b.title}</p>
                <p className="text-sm text-white/55 leading-relaxed">{b.desc}</p>
              </motion.div>
            );
          })}
        </div>

        <div className="flex flex-wrap items-center gap-3">
          <Link
            to="/partners"
            data-testid="merchant-section-cta"
            className="inline-flex items-center gap-2 px-6 py-3.5 rounded-full bg-ih-electric text-white font-semibold hover:scale-[1.02] transition ih-shadow-blue"
          >
            Partner With Us <ArrowUpRight weight="bold" size={16} />
          </Link>
          <Link to="/services" className="text-sm text-white/60 hover:text-white transition underline underline-offset-4 decoration-ih-line2">
            Explore all services
          </Link>
        </div>
      </div>
    </section>
  );
}
